// Which leagues' Game Days a Sunday flips through (F7, MATCHUP.md "Flipping
// to the next league's Game Day", DIRECTION U31): every league on my hub
// where I have a team with a game to follow this week, a matchup or my week
// against the field, in the hub's order. The same set from whichever of them
// is on screen, so the count and the ends never move mid-flip; a league
// outside it (a bye, a league in setup) has no strip (the review of
// 2026-11-01).

import type { LeagueCard } from '@fsp/domain';

export interface FlipStop {
  id: string;
  name: string;
}

/**
 * The hub's leagues as the hub lays them out: a sport's together, the sports
 * in the order their first league comes. One rule for the hub and the flip,
 * so the two agree.
 */
export function leaguesBySport<T extends { league: { sport: string } }>(
  leagues: readonly T[],
): Map<string, T[]> {
  const groups = new Map<string, T[]>();
  for (const l of leagues) {
    const g = groups.get(l.league.sport) ?? [];
    g.push(l);
    groups.set(l.league.sport, g);
  }
  return groups;
}

/**
 * The flip's leagues and where the one on screen is among them, or null with
 * fewer than two to flip through, or when the league on screen is not one.
 */
export function gameDaysOf(
  leagues: readonly LeagueCard[],
  currentId: string | null,
): { stops: FlipStop[]; at: number } | null {
  if (currentId === null) return null;
  const stops = [...leaguesBySport(leagues).values()]
    .flat()
    .filter((c) => c.myTeam !== null && (c.matchup !== null || c.field !== null))
    .map((c) => ({ id: c.league.id, name: c.league.name }));
  const at = stops.findIndex((s) => s.id === currentId);
  return at < 0 || stops.length < 2 ? null : { stops, at };
}
